module.exports = __webpack_public_path__ + "img/footer-right.2b13a00c.svg";